import { render, staticRenderFns } from "./HelpFeedback.vue?vue&type=template&id=33984ba6&scoped=true&"
import script from "./HelpFeedback.vue?vue&type=script&lang=js&"
export * from "./HelpFeedback.vue?vue&type=script&lang=js&"
import style0 from "./HelpFeedback.vue?vue&type=style&index=0&id=33984ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33984ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabs})
